import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslateConfigService {
  private readonly LANG_KEY = 'snatchit_lang';

  constructor(private translate: TranslateService) {}

  init() {
    this.translate.addLangs(['en', 'zh']);
    const saved = localStorage.getItem(this.LANG_KEY);
    const lang = saved && ['en', 'zh'].includes(saved) ? saved : 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(lang);
  }

  getLanguage(): string {
    return this.translate.currentLang || 'en';
  }

  setLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem(this.LANG_KEY, lang);
  }

  toggleLanguage() {
    const next = this.getLanguage() === 'en' ? 'zh' : 'en';
    this.setLanguage(next);
  }
}
